import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { Select } from 'components/molecules/Select';
import { colors } from 'theme/colors';

export const StyledSelect = styled(Select)`
  & .MuiOutlinedInput-root {
    height: 40px;
  }
`;

export const StyledWarningSearch = styled(Grid)`
  margin-bottom: 25px;
`;

export const StyledNoComments = styled(Grid)`
  background: ${colors.gray100};
  padding: 20px;
  border: 1px solid ${colors.gray200};
  border-radius: 4px;
  color: ${colors.gray400};
  font-style: Italic;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
`;
